import { defineWave } from '../schema';

/** BLOC B2 — premier Faucheur.
 *
 *  Introduit seul, avec son télégraphe de 1,1 s — plus long que celui du
 *  popcorn, parce que plus un ennemi est dangereux, plus le joueur a besoin de
 *  temps pour replanifier sa trajectoire.
 *
 *  Son éventail de 3 projectiles visés est la première menace que l'esquive
 *  latérale simple ne suffit pas à traiter : il faut anticiper l'ouverture. */
export default defineWave({
  id: 'b2-faucheur',
  duration: 16,
  spawns: [
    { at: 0.5, enemy: 'faucheur', lane: 3, count: 1, spacing: 0 },
    { at: 3.0, enemy: 'mite', lane: 1, count: 5, spacing: 0.08 },
    { at: 3.4, enemy: 'mite', lane: 5, count: 5, spacing: 0.08 },
    { at: 6.5, enemy: 'faucheur', lane: 2, count: 1, spacing: 0 },
    { at: 6.9, enemy: 'faucheur', lane: 4, count: 1, spacing: 0 },
    { at: 10.0, enemy: 'eclat', lane: 3, count: 4, spacing: 0.6 },
    { at: 13.0, enemy: 'mite', lane: 2, count: 6, spacing: 0.07 },
    { at: 13.4, enemy: 'mite', lane: 4, count: 6, spacing: 0.07 },
  ],
});
